import React from 'react';
import businessData from '../data/businessdata.json';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const MobileStickyCTA = () => {
  const { t } = useLanguage();

  return (
    <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-gray-100 p-3 z-40 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
      <div className="grid grid-cols-2 gap-3">
        <a 
          href={`tel:${businessData.phoneRaw}`}
          className="flex items-center justify-center gap-2 bg-brand text-white py-3.5 rounded-xl font-black text-sm"
        >
          <SafeIcon name="Phone" />
          {t('mobile.call')}
        </a>
        <a 
          href={`https://wa.me/${businessData.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-[#25D366] text-white py-3.5 rounded-xl font-black text-sm"
        >
          <SafeIcon name="MessageCircle" />
          {t('mobile.whatsapp')}
        </a>
      </div>
    </div>
  );
};

export default MobileStickyCTA;